import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
@Component({
    name: 'tool-pull-up',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class ToolPullUp extends Vue {

    // ----------------------------------------------------------
    // Properties
    @Prop()
    private toolProvider: any;

    @Prop()
    private activeTool: any;

    @Prop()
    private isCompareToggle!: boolean;

    @Prop()
    private toolDataBySubject: any;

    @Prop()
    private activeCompareData: any;



    // --------------------------------------------------------------
    // Hooks


    // ------------------------------------------------------------------
    // Actions

    private onSelectLogo(data: any) {
        data.isActive = true;
        this.activeCompareData.push(data);
    }

    private onConfirmCompare() {
        this.$bvModal.hide('modal-sm');
        this.$bvModal.show('modal-compare');
        this.activeCompareData.push(this.activeTool);
        this.isCompareToggle = false;
    }
    private onCancelCompare(isClearComparedata: boolean = true) {
        this.resetData(isClearComparedata);
        this.$root.$emit('bv::toggle::collapse', 'accordion-1');
    }

    private resetData(isClearComparedata: boolean = true) {
        this.$emit('resetData', isClearComparedata);
    }

    // ------------------------------------------------------------------------
    // methods


}
